import React, { Component } from 'react'

import Generator from './Generator'
import LandingPage from './LandingPage'

class App extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      view: 'landing',
    };
    this.goToLandingPage = this.goToLandingPage.bind(this)
    this.goToGenerator = this.goToGenerator.bind(this)
  }

  goToLandingPage() {
    this.setState({
      view: 'landing',
    });
  }
  goToGenerator() {
    this.setState({
      view: 'generator',
    });
  }

  render() {
    var backgroundStyle

    switch (this.state.view) {
      case 'generator':
        return (
          <Generator clickHandler={this.goToLandingPage}/>
        );
      case 'landing':
        return (
          <LandingPage clickHandler={this.goToGenerator} />
        );
      default:
        return (
          <div>default</div>
        );
    }
  }
}

export default App


// WEBPACK FOOTER //
// ./src/scripts/components/App.js